export const APPLICATION_TYPES = [
  { value: 'ISSUE', label: 'Issue' },
  { value: 'EXTENSION', label: 'Extension' },
  { value: 'RENEWAL', label: 'Renewal' }
];

export const EMPLOYMENT_TYPES = [
  { value: 'PERMANENT', label: 'Permanent' },
  { value: 'CONTRACT', label: 'Contract' }
];

export const STATUS_LABELS = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted (MRO Manager)',
  RETURNED_TO_APPLICANT: 'Returned to applicant',
  ACCEPTED_BY_MRO_MANAGER: 'Accepted by MRO Manager',
  ACCEPTED_BY_MRO_QM: 'Accepted by MRO QM',
  BOARD_FORMED: 'Board formed',
  ASSESSMENT_IN_PROGRESS: 'Assessment in progress',
  ASSESSMENT_COMPLETE: 'Assessment complete',
  ISSUED: 'Authorization issued',
  NOT_ISSUED: 'Not issued',
  CANCELLED: 'Cancelled'
};

export const STATUS_COLORS = {
  DRAFT: 'default',
  SUBMITTED: 'info',
  RETURNED_TO_APPLICANT: 'warning',
  ACCEPTED_BY_MRO_MANAGER: 'info',
  ACCEPTED_BY_MRO_QM: 'info',
  BOARD_FORMED: 'info',
  ASSESSMENT_IN_PROGRESS: 'warning',
  ASSESSMENT_COMPLETE: 'info',
  ISSUED: 'success',
  NOT_ISSUED: 'error',
  CANCELLED: 'default'
};

export const FORM_REFS = {
  application: 'GETS/CM/008',
  competency: 'GETS/CM/003',
  certificate: 'GETS/CM/001'
};

/** GETS/CM/003 Section B — 31 competency lines */
export const COMPETENCY_ITEMS = [
  { slNo: 1, description: 'Knowledge of Safety Management, Human factors, human performance, and limitations, and just culture.' },
  { slNo: 2, description: 'Knowledge of organization capabilities, privileges and limitations.' },
  { slNo: 3, description: 'Knowledge of CAR-M, CAR-145 and any other relevant regulations.' },
  { slNo: 4, description: 'Knowledge of relevant parts of the MOE and procedures.' },
  { slNo: 5, description: 'Knowledge of occurrence reporting (mandatory and voluntary), internal reporting scheme and understanding of the importance of reporting occurrences, incorrect maintenance data and existing or potential defects.' },
  { slNo: 6, description: 'Knowledge of safety risks linked to the working environment.' },
  { slNo: 7, description: 'Knowledge on CDCCL when relevant.' },
  { slNo: 8, description: 'Knowledge on EWIS when relevant.' },
  { slNo: 9, description: 'Understanding of professional integrity, behavior and attitude towards safety.' },
  { slNo: 10, description: 'Understanding of conditions for ensuring continuing airworthiness of aircraft and components.' },
  { slNo: 11, description: 'Understanding of his/her own human performance and limitations.' },
  { slNo: 12, description: 'Understanding of personnel authorizations and limitations.' },
  { slNo: 13, description: 'Understanding critical maintenance tasks.' },
  { slNo: 14, description: 'Ability to compile and control completed work cards.' },
  { slNo: 15, description: 'Ability to consider human performance and limitations.' },
  { slNo: 16, description: 'Ability to determine required qualifications for task performance.' },
  { slNo: 17, description: 'Ability to identify and rectify existing and potential unsafe conditions.' },
  { slNo: 18, description: 'Ability to confirm proper accomplishment of maintenance tasks.' },
  { slNo: 19, description: 'Ability to identify and properly plan performance of critical maintenance task.' },
  { slNo: 20, description: 'Ability to priorities tasks and report discrepancies.' },
  { slNo: 21, description: 'Ability to process the work requested by the operator.' },
  { slNo: 22, description: 'Ability to properly process removed, uninstalled and rejected parts.' },
  { slNo: 23, description: 'Ability to properly record and sign for work accomplished.' },
  { slNo: 24, description: 'Ability to recognize the acceptability of parts to be installed prior to fitment.' },
  { slNo: 25, description: 'Ability to split complex maintenance tasks into clear stages.' },
  { slNo: 26, description: 'Ability to understand work orders, work cards and refer to and use applicable maintenance data.' },
  { slNo: 27, description: 'Ability to use information systems.' },
  { slNo: 28, description: 'Ability to use, control and be familiar with required tooling and/or equipment.' },
  { slNo: 29, description: 'Adequate communication and literacy skills.' },
  { slNo: 30, description: 'Teamwork, decision-making and leadership skills.' },
  { slNo: 31, description: 'Knowledge of relevant shop related tasks.' }
];

export const emptyCompetencyRows = () =>
  COMPETENCY_ITEMS.map((item) => ({
    slNo: item.slNo,
    description: item.description,
    remarks: '',
    assessorSignature: ''
  }));
